import React from "react";
import PropTypes from "prop-types";
import Notification from "../../../../components/Notification";
import { Check, X } from "react-feather";
import { useSpring, animated, config } from "@react-spring/web";
import i18next from "i18next";

/**
 * Wrapper around the notification component to
 * display a notification message on customer area page
 * see Figma edit profile|password on customer area
 * @returns JSX component
 */
const CustomerNotification = ({ show, path, variant = "success" }) => {
    const animation = useSpring({
        opacity: show ? 1 : 0,
        config: { ...config.molasses, duration: 400 },
    });

    if (show) {
        return (
            <animated.div style={animation} id="customer-area-notification">
                <Notification type={variant}>
                    {variant === "success" ? (
                        <Check size={48} className="check-icon" />
                    ) : (
                        <X size={48} className="X-icon" />
                    )}
                    <span className="title">
                        {i18next.t(`customerArea.${path}.${variant}Title`)}
                    </span>
                    <span className="description">
                        {i18next.t(
                            `customerArea.${path}.${variant}Description`
                        )}
                    </span>
                </Notification>
            </animated.div>
        );
    }
    return null;
};

CustomerNotification.propTypes = {
    show: PropTypes.bool,
    path: PropTypes.string,
    variant: PropTypes.oneOf(["success", "danger"]),
};

export default CustomerNotification;
